import React, { useEffect, useState } from "react";
import PricingCard from "../components/pricing/PricingCard";
import {
  formatPriceWithLocale,
  getCurrencySymbol,
  getPrice,
  SUPPORTED_CURRENCIES,
} from "../utils/pricing";
import axios from "axios";
import { BASE_URL, getSubscriptionStatus } from "../utils/tools";
import connectToDb from "../utils/mongodb";
import { firebaseAdmin } from "../utils/firebaseAdmin";
import CreditCheckoutModal from "../components/modals/CreditCheckoutModal";
import Head from "next/head";
import { SecondaryButton } from "@jammable/ui-core";
import { toast } from "react-hot-toast";
import { useRouter } from "next/router";
import { NextSeo } from "next-seo";
const PricingPage2 = ({ status, currency, symbol }) => {
  const [clientSecret, setClientSecret] = useState(null);
  const [creditModal, setCreditModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const router = useRouter();

  useEffect(() => {
    if (clientSecret) {
      setCreditModal(true);
    }
  }, [clientSecret]);

  const faqs = [
    {
      question: "What is included in the Basic plan?",
      answer:
        "The Basic plan includes 30 monthly covers, access to the full Jammable voice library, text to speech, duets, and your credits never expire.",
    },
    {
      question: "How does the Creator plan differ from Basic?",
      answer:
        "The Creator plan offers unlimited covers, the ability to train 5 monthly voices, create shareable videos, plus all features available in the Basic plan.",
    },
    {
      question: "Can I cancel my subscription anytime?",
      answer:
        "Yes, you can cancel your subscription at any time. Your benefits will remain active until the end of your billing period.",
    },
    {
      question: "Can I upgrade/downgrade my plan?",
      answer:
        "Yes, you can upgrade or downgrade your plan at any time. Your benefits will be updated accordingly.",
    },
  ];

  const cards = [
    {
      plan: "basic",
      status: status,
      currency: currency,
      symbol: symbol,
      price: getPrice(currency, "basic"),
      originalPrice: getPrice(currency, "basic-discount"),
      benefits: [
        {
          title: "30 Monthly Covers",
          color: "tw-bg-cyan-100",
        },
        {
          title: "Full Jammable Voice Library",
          color: "tw-bg-yellow-200",
        },
        {
          title: "Credits Never Expire",
          color: "tw-bg-pink-200",
        },
        {
          title: "Text to Speech",
          color: "tw-bg-green-200",
        },
        {
          title: " Duets",
          color: "tw-bg-red-300",
        },
      ],
    },
    {
      plan: "creator",
      status: status,
      currency: currency,
      symbol: symbol,
      description: "The best way to learn to sing",
      price: getPrice(currency, "creator"),
      originalPrice: getPrice(currency, "creator-discount"),
      benefits: [
        {
          title: "Unlimited Covers",
          color: "tw-bg-cyan-100",
        },
        {
          title: "Train 5 Monthly Voices",
          color: "tw-bg-yellow-200",
        },
        {
          title: "Duets",
          color: "tw-bg-pink-200",
        },
        {
          title: "Full Jammable Voice Library",
          color: "tw-bg-green-200",
        },
        {
          title: "Text to Speech",
          color: "tw-bg-red-300",
        },
        {
          title: "Create Shareable Videos",
          color: "tw-bg-blue-200",
        },
      ],
    },
  ];

  const title = "Pricing | Jammable";
  const description =
    "Create AI-generated songs with your favorite voices for free! Explore Jammable's flexible pricing plans tailored for AI-powered music creation enthusiasts of all levels.";

  const url = `${BASE_URL}/pricing`;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{ title: title, description: description, url: url }}
      />
      <div className="container ">
        <div
          className="main"
          style={{
            marginTop: 20,
          }}
        >
          {/* Hero Section - More integrated design */}
          <div className="tw-bg-gradient-to-b tw-from-purple-50 tw-to-white tw-rounded-3xl tw-py-4 tw-px-6 tw-mb-4 tw-w-full tw-shadow-sm">
            <div className="tw-relative">
              <div
                className="tw-absolute tw-inset-0"
                style={{
                  backgroundImage:
                    "url(\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%239C92AC' fill-opacity='0.05' fill-rule='evenodd'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 20.83l2.83-2.83 1.41 1.41L1.41 22.24H0v-1.41zM0 3.07l2.83-2.83 1.41 1.41L1.41 4.48H0V3.07zM17.76 38.59l2.83-2.83 1.41 1.41-2.83 2.83h-1.41v-1.41zM17.76 20.83l2.83-2.83 1.41 1.41-2.83 2.83h-1.41v-1.41zM17.76 3.07l2.83-2.83 1.41 1.41-2.83 2.83h-1.41V3.07zM35.52 38.59l2.83-2.83 1.41 1.41-2.83 2.83h-1.41v-1.41zM35.52 20.83l2.83-2.83 1.41 1.41-2.83 2.83h-1.41v-1.41zM35.52 3.07l2.83-2.83 1.41 1.41-2.83 2.83h-1.41V3.07z'/%3E%3C/g%3E%3C/svg%3E\")",
                  backgroundSize: "30px 30px",
                }}
              ></div>
              <div className="tw-relative tw-z-10">
                <h1 className="tw-text-2xl md:tw-text-3xl tw-font-black tw-my-0 tw-py-0 tw-text-center tw-uppercase tw-tracking-wider tw-mb-1  tw-text-black">
                  Choose Your Plan!
                </h1>
                <div className="tw-text-md tw-text-black/50 tw-text-center tw-max-w-2xl tw-mx-auto tw-font-semibold">
                  No commitment, cancel anytime.
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          <CreditCheckoutModal
            clientSecret={clientSecret}
            opened={creditModal}
            setOpened={setCreditModal}
            symbol={symbol}
            currency={currency}
            price={selectedPlan?.price}
          />

          {/* Pricing Cards */}
          <div className="tw-flex tw-w-full tw-gap-8 md:tw-flex-row tw-flex-col tw-mb-8">
            {cards.map((card) => (
              <PricingCard
                key={card.plan}
                plan={card.plan}
                status={card.status}
                currency={card.currency}
                price={card.price}
                originalPrice={card.originalPrice}
                benefits={card.benefits}
                setClientSecret={setClientSecret}
                onSelect={() => setSelectedPlan(card)}
              />
            ))}
          </div>

          {/* FAQ Section */}
          <div className="tw-mb-4 tw-mt-32">
            <h2 className="tw-text-3xl tw-font-black tw-text-center tw-uppercase tw-mt-0 tw-mb-4 tw-tracking-wide">
              Frequently Asked Questions
            </h2>
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-5">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="tw-bg-gray-50 tw-rounded-xl tw-p-4 tw-shadow-sm tw-border tw-border-gray-100"
                >
                  <h3 className="tw-font-bold tw-text-xl tw-mb-2">
                    {faq.question}
                  </h3>
                  <div className="tw-text-gray-600">{faq.answer}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Enhanced CTA Section with texture */}
          <div className="tw-relative tw-overflow-hidden tw-rounded-3xl tw-mb-8 tw-w-full tw-mt-14">
            <div className="tw-absolute tw-inset-0 tw-bg-purple-700 tw-opacity-90"></div>
            <div
              className="tw-absolute tw-inset-0"
              style={{
                backgroundImage:
                  "url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E\")",
                backgroundSize: "cover",
              }}
            ></div>
            <div className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-gradient-to-br tw-from-purple-600 tw-to-indigo-700 tw-opacity-80"></div>
            <div className="tw-relative tw-z-10 tw-p-6 md:tw-py-16 tw-text-center tw-text-white">
              <div className="tw-max-w-3xl tw-mx-auto">
                <h2 className="tw-text-4xl tw-font-extrabold tw-mb-4 tw-tracking-tight">
                  Ready to start creating?
                </h2>
                <div className="tw-text-xl tw-mb-4 tw-text-purple-50 tw-max-w-xl tw-mx-auto tw-opacity-90">
                  Choose a plan today and begin your journey with Jammable
                </div>
                <SecondaryButton
                  onClick={() =>
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    })
                  }
                  className="tw-bg-white tw-text-purple-700 tw-font-bold tw-py-4 tw-px-12 tw-rounded-full tw-text-lg hover:tw-bg-opacity-90 tw-transition-all tw-duration-300 tw-shadow-xl hover:tw-shadow-2xl hover:tw-transform hover:tw-translate-y-[-2px] hover:tw-text-purple-800 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-purple-300 focus:tw-ring-opacity-50"
                >
                  Select a Plan
                </SecondaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PricingPage2;

export const getServerSideProps = async ({ req }) => {
  try {
    const token = req?.cookies?.token;
    // Default to USD
    let currency = "USD";
    let symbol = getCurrencySymbol(currency);

    const forwarded = req.headers["x-forwarded-for"];

    const ip =
      process.env.NODE_ENV === "production"
        ? forwarded
          ? forwarded.split(/, /)[0]
          : req.socket.remoteAddress
        : "86.23.252.218";

    const timeout = 3000; // 3 seconds
    const dataPromise = axios.get(`http://www.geoplugin.net/json.gp?ip=${ip}`);

    const timeoutPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error("API call timed out"));
      }, timeout);
    });

    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data = await Promise.race([dataPromise, timeoutPromise]);
      const detectedCurrency = data?.data?.geoplugin_currencyCode;

      // Check if the detected currency is supported
      if (detectedCurrency && SUPPORTED_CURRENCIES.includes(detectedCurrency)) {
        currency = detectedCurrency;
        symbol = getCurrencySymbol(currency);
      }
    } catch (error) {
      console.log(error);
      // Fallback to USD in case of error
      currency = "USD";
      symbol = getCurrencySymbol(currency);
    }

    // For testing specific currencies, uncomment and modify the following:
    // currency = "INR";
    // symbol = getCurrencySymbol(currency);

    if (token) {
      const a = await firebaseAdmin.auth().verifyIdToken(token);
      await connectToDb();
      const subData = await axios
        .get(`${BASE_URL}/api/user/getUserData`, {
          params: {
            firebaseUid: a.uid,
          },
          headers: {
            Authorization: token,
          },
        })
        .catch(() => {});

      console.log(
        "subscription status",
        subData?.data?.subscriptions,
        getSubscriptionStatus(subData?.data?.subscriptions),
      );
      return {
        props: {
          status: getSubscriptionStatus(subData?.data?.subscriptions),
          currency: currency,
          symbol: symbol,
        },
      };
    } else {
      return {
        props: {
          currency: currency,
          symbol: symbol,
        },
      };
    }
  } catch (error) {
    // Fallback to USD in case of any errors
    return {
      props: {
        currency: "USD",
        symbol: getCurrencySymbol("USD"),
      },
    };
  }
};
